{
  "title": "PoultryNEXT Layers",
  "title_Agrifirm": "PoultryNEXT Layers",
  "home": "Home",
  "save": "Save",
  "save-and-next-week": "Save and go to next week",
  "week": "Week",
  "app": {
    "flock": "Layer Flock",
    "settings": "Settings",
    "management": "Management",
    "products": "Products",
    "advices": "Advices",
    "feed-advice": "Feed advice",
    "reference-scheme": "Reference feed advices",
    "breeders": "Breeder Flock"
  },
  "settings": {
    "navigation": {
      "barns": "Barns",
      "sustainability": "Sustainability"
    },
    "barn": "Stal",
    "no-barns": {
      "description": "Add a barn and it will show up here.",
      "title": "No barns"
    },
    "barn-item": {
      "title-create": "Create Barn",
      "title-edit": "Edit Barn",
      "add": "Add",
      "area": "Surface area",
      "name": "Barn description",
      "error-name-duplicate": "This barn name is already in use. Enter a unique barn name",
      "error-name-required": "Enter the barn name",
      "error-surface-area": "Enter the surface area",
      "delete-item": "Do you want to delete the barn?",
      "silo": "Silo"
    }
  },
  "egg-marketing-standards": {
    "organic": "Organic",
    "free-range": "Free Range",
    "cage-free": "Cage free",
    "caged": "Caged"
  },
  "flock-saved": "The flock was saved.",
  "confirm-delete-flock": "Are you sure you want to delete the flock?",
  "flock-deleted": "The flock was deleted.",
  "flock-overview": {
    "flock": "Flock",
    "placeholder": "Select a flock",
    "selector-option-flock": "Flock",
    "selector-option-barn": "Barn",
    "print": "Print report(s)",
    "new-flock": "New flock",
    "add-week": "Add week",
    "download-all": "Flock Report (.pdf)",
    "download-animal-count": "Animal Count Report (.pdf)",
    "download-summary": "Download summary (.pdf)",
    "panel": {
      "arrival-title": "Arrival",
      "weekregistrations-title": "Week registrations",
      "departure-title": "Departure",
      "add-arrival": "Add arrival",
      "add-departure": "Add departure",
      "edit-arrival": "Edit arrival",
      "edit-departure": "Edit departure",
      "emptymessage-arrival": "You should add an arrival for this flock first.",
      "emptymessage-weekregistrations": "You did not fill in any week registrations so far.",
      "emptymessage-departure": "You did not define a departure yet.",
      "flock-id": "Flock ID",
      "egg-marketing-standard": "Egg Marketing Standard",
      "hatchery-name": "Hatchery",
      "amount-of-hens": "Amount of hens",
      "breed-name": "Breed",
      "barn-name": "Barn",
      "chick-birthdate": "Birth Date",
      "arrival-date": "Arrival Date",
      "delete": "Delete flock",
      "departure-date": "Departure date",
      "departure-amount": "Amount",
      "departure-weight": "Hen weight (g)",
      "housing-system": "Housing system",
      "amount-of-roosters": "Amount of roosters",
      "delete-breeder-flock": "Delete flock",
      "feed-system-hens": "Feed hens",
      "feed-system-roosters": "Feed roosters",
      "drink-system": "Drink system",
      "hen-weight": "Hen weight (g)",
      "rooster-weight": "Rooster weight (g)",
      "nest": "Nest",
      "rearing-organization": "Rearing organization",
      "transport-distance": "Transport from rearing facility (km)"
    },
    "week-registrations": {
      "sortByAscending": "Week ascending",
      "sortByDescending": "Week descending",
      "edit": "Edit",
      "delete": "Delete",
      "kpis": {
        "AverageEggWeight": "Avg egg weight",
        "AverageEggWeightPerLayerPerDay": "Egg weight per layer",
        "AverageLayerWeight": "Layer Weight",
        "EggCountPerLayerInProduction": "Eggs per layer",
        "EggCountPerLayerInProductionCumulative": "Eggs per layer cum",
        "FeedConsumption": "Feed weight",
        "FeedConsumptionPerLayerInProduction": "Feed weight per layer",
        "FeedConsumptionPerLayerInProductionCumulative": "Feed weight per layer cum (kg)",
        "FeedConsumptionPerLayerPerDay": "Feed per layer per day",
        "FeedConsumptionPerLayerPerDayCumulative": "Feed per layer per day cum",
        "FeedConversionRate": "Feed conversion",
        "FeedConversionRateCumulative": "Feed conversion cum",
        "FeedToEggRatio": "Feed to egg",
        "MortalityCount": "Mortality count",
        "MortalityRate": "Mortality rate",
        "MortalityRateCumulative": "Mortality rate cum",
        "RateOfLay": "Rate of lay",
        "TotalEggCount": "Egg count",
        "TotalEggCountSecondGrade": "Egg count second grade",
        "TotalEggWeight": "Total egg weight",
        "TotalEggWeightPerLayerInProductionCumulative": "Egg weight per layer cum (kg)",
        "WaterConsumption": "Water",
        "WaterToFeedRatio": "Water to feed",
        "SecondFeedConsumption": "Second Feed weight"
      },
      "breeder-kpis": {
        "EggCount": "Egg count",
        "EggWeightInGrams": "Average egg weight",
        "FertilityPercentage": "Fertility",
        "HatchPercentage": "Hatch rate",
        "HatchingEggCount": "Hatching egg count",
        "HenCount": "Hens count",
        "HenFeedIntakeInGrams": "Hen feed intake",
        "HenMortality": "Hen mortality",
        "HenWeight": "Hen weight",
        "LightHours": "Light hours",
        "LightIntensity": "Light intensity",
        "RoosterCount": "Roosters count",
        "RoosterMortality": "Rooster mortality",
        "RoosterPercentage": "Rooster percentage",
        "RoosterFeedIntakeInGrams": "Rooster feed intake",
        "RoosterWeight": "Rooster weight",
        "RateOfLay": "Rate of lay",
        "AverageEggWeight": "Average egg weight",
        "EggMassPerBreeder": "Egg mass per breeder",
        "FeedPerBreeder": "Feed per breeder",
        "FeedPerBreederPerDay": "Feed per breeder per day",
        "FeedPerHatchedEgg": "Feed per hatching egg",
        "FeedToEggRatio": "Feed per egg",
        "FeedConversion": "Feed conversion",
        "WaterToFeedRatio": "Water to feed ratio",
        "MortalityRate": "Mortality rate",
        "ProductionFigure": "Production figure",
        "HatchedEggsPerPlacedHen": "Hatching eggs per placed hen",
        "HenMortalityRate": "Hen mortality rate",
        "RoosterMortalityRate": "Rooster mortality rate",
        "TotalFeedPerWeek": "Total feed (week)",
        "WaterInLiters": "Water",
        "HenWaterIntakeInLiters": "Hen water intake",
        "RoosterWaterIntakeInLiters": "Rooster water intake",
        "HatchedEggsCumulative": "Hatched eggs cumulative",
        "HatchPercentageCumulative": "Hatch percentage cumulative",
        "RateOfLayCumulative": "Rate of lay cumulative",
        "AverageEggWeightCumulative": "Average egg weight cumulative",
        "EggMassPerBreederCumulative": "Egg mass per breeder cumulative",
        "FeedPerBreederCumulative": "Feed per breeder cumulative",
        "FeedPerBreederPerDayCumulative": "Feed per breeder per day cumulative",
        "FeedPerHatchedEggCumulative": "Feed per hatching egg cumulative",
        "FeedToEggRatioCumulative": "Feed per egg cumulative",
        "FeedConversionCumulative": "Feed conversion cumulative",
        "WaterToFeedRatioCumulative": "Water to feed ratio cumulative",
        "MortalityRateCumulative": "Mortality rate cumulative",
        "HatchedEggsPerPlacedHenCumulative": "Hatched eggs per placed hen cumulative",
        "HenMortalityRateCumulative": "Hen mortality rate cumulative",
        "RoosterMortalityRateCumulative": "Rooster mortality rate cumulative"
      },
      "view-filters": {
        "kpis": "KPI's",
        "manual-input": "Manual input",
        "moult": "Rui",
        "remarks": "Remarks",
        "detailed": "Detailed"
      },
      "filters": {
        "title": "Graph settings",
        "description": "Here you will find the graph settings.",
        "labels": {
          "breed-category-name": "Breed category",
          "egg-marketing-standard": "Egg Marketing Standard",
          "breed-name": "Breed",
          "data-sources": "Shown data sources",
          "other-flock-placeholder": "Select a flock",
          "selector-option-barn": "barn"
        },
        "breed-categories": {
          "overall": "Average",
          "white": "White",
          "brown": "Brown"
        },
        "egg-marketing-standards": {
          "0": "Organic",
          "1": "Free Range",
          "2": "Cage free",
          "3": "Caged"
        },
        "breeds": {
          "Overall": "Average"
        },
        "chart-lines": {
          "current-flock": "Selected flock",
          "breeders-reference-benchmark": "Breeders reference",
          "porphyrio-benchmark": "Porphyrio benchmark",
          "other-flock": "Other flock",
          "other-flock-lower-case": "other flock"
        }
      },
      "benchmark": {
        "title": "Weekly overview of",
        "description": "Here you can find an weekly overview of the KPI:",
        "breedersReference": "Breeders Reference",
        "cumulative": "Cumulative",
        "porphyrioBenchmark": "Porphyrio benchmark",
        "flocks": "flocks",
        "error": {
          "no-data-sources-title": "No data sources available",
          "no-data-sources-description": "A weekly overview cannot be displayed because no data sources have been selected.",
          "no-data-title": "No data available",
          "no-data-description": "There is no data is available for one or more enabled data source(s)."
        },
        "axis": {
          "week": "Week",
          "values": "Values"
        }
      },
      "weekregistration-download": "Download template",
      "weekregistration-upload": "Import",
      "weekregistration-select-file": "Select file...",
      "weekregistration-upload-csv-title": "Select a CSV file to import",
      "upload-csv-message": "Columns should not be removed from the template, even if they are empty. Fields can be left empty.",
      "upload-csv-notification": "Select a CSV file to import",
      "weekregistration-select-interval-type": "Interval type",
      "interval-type-Day": "Day",
      "interval-type-Week": "Week",
      "validation-errors": {
        "total-must-be-100": "The total must be 100",
        "date-is-not-valid-title": "The date is incorrect",
        "date-is-not-valid-description": "The date is incorrect"
      },
      "date": "Date",
      "days": "Days",
      "weeks": "Weeks",
      "jump-to-week": "Jump to week"
    },
    "no-flocks": {
      "title": "No flocks",
      "description": "Add a flock and it will show up here."
    },
    "unassigned": "Unassigned",
    "new-breeder-flock": "New flock"
  },
  "week-registration": {
    "mortality": "Mortality",
    "eggsAmount": "Total amount of eggs",
    "eggsAmountSecondKind": "Amount of eggs 2nd kind",
    "eggWeight": "Egg weight",
    "forage": "Feed",
    "water": "Water",
    "henWeight": "Hen Weight",
    "moult": "Moult",
    "isInMoult": "Moult?",
    "isInMoultMessage": "Are the hens in moult this week?",
    "moult-true": "Yes",
    "moult-false": "No",
    "remarks": "Remarks",
    "amountOfHensStartOfWeek": "Amount of hens at start of week",
    "amountOfRoostersStartOfWeek": "Amount of roosters at start of week",
    "amountOfHensStartOfFlock": "Amount of hens at start of flock",
    "amountOfRoostersStartOfFlock": "Amount of roosters at start of flock",
    "henMortality": "Hen mortality",
    "roosterMortality": "Rooster mortality",
    "roosterWeight": "Rooster weight",
    "henFeedIntakeInGrams": "Hen feed intake",
    "roosterFeedIntakeInGrams": "Rooster feed intake",
    "henWaterIntakeInLiters": "Hen water intake",
    "roosterWaterIntakeInLiters": "Rooster water intake",
    "eggCount": "Egg count",
    "hatchingEggCount": "Hatching egg count",
    "eggWeightInGrams": "Egg weight",
    "fertilityPercentage": "Fertility",
    "hatchPercentage": "Hatch",
    "lightHours": "Light hours",
    "lightIntensity": "Light intensity",
    "breed": "Breed",
    "barn": "Barn",
    "dateOfBirth": "Date of Birth",
    "arrivalDate": "Arrival date",
    "week": "Week",
    "week-start": "Week start",
    "registration": "registration",
    "period": "Period",
    "out-of-range": "This value is out of bounds. Only these values are allowed:",
    "whole-number-required": "Enter a whole number (without decimals).",
    "hatching-egg-count-exceeds-egg-count": "The number of hatching eggs cannot exceed the number of eggs",
    "hatch-greater-than-fertility": "The hatch percentage must be lower than the fertility percentage",
    "too-much-mortality": "The sum of all mortality is larger than the amount of hens at the start of the week!",
    "forageProduct": "Feed Product",
    "secondForageToggle": "Add Second Feed Product",
    "secondForage": "Second Feed",
    "secondForageProduct": "Second Feed Product",
    "weekly-registrations": "Weekly Observation Registrations",
    "daily-registrations": "Daily Observation Registrations"
  },
  "arrival-detail": {
    "title-edit": "Edit Arrival",
    "title-create": "Create Arrival",
    "flock-name": "Flock name",
    "barn": "Barn",
    "chick-birthdate": "Birth date",
    "arrival-date": "Arrival date",
    "production-period-start-date": "Start production period",
    "breed": "Breed",
    "amount-of-hens": "Amount of hens",
    "egg-marketing-standard": "Egg Marketing Standard",
    "hatchery": "Hatchery",
    "input-mode": "Input method",
    "input-mode-per-day": "Daily",
    "input-mode-per-week": "Weekly",
    "input-mode-advanced": "Advanced",
    "advanced-link": "Enter advanced settings >",
    "back-to-general-data": "< back",
    "advanced-settings-title": "Advanced input settings",
    "days": "days",
    "age-start-production-period": "Age at start of production period",
    "housing-system": "Housing system",
    "bedding-type": "Bedding type",
    "bedding-amount": "Bedding amount",
    "transport-distance": "Transport from rearing facility",
    "transport-distance-error": "Transport from rearing facility must be a number between 0 and 1000",
    "bedding-amount-error": "Bedding amount must be a positive number",
    "time-in-free-range": "Time in free range",
    "time-in-free-range-error": "Time in free range must be a number between 0 and 100",
    "hen-weight": "Hen weight",
    "hen-weight-error": "Hen weight must be a positive number",
    "hen-weight-comparison-error": "Weight must be lesser than on departure",
    "minimum-amount-of-hens-error": "Amount of hens must be a positive number",
    "rearing-organization": "Rearing organization",
    "amount-of-roosters": "Amount of roosters",
    "minimum-amount-of-roosters-error": "Amount of roosters must be a positive number",
    "show-rooster-fields": "Register roosters",
    "rooster-weight": "Rooster weight",
    "rooster-weight-error": "Rooster weight must be a positive number",
    "feed-system-hens": "Feed system hens",
    "feed-system-roosters": "Feed system roosters",
    "drink-system": "Drink system",
    "nest": "Nest"
  },
  "departure-detail": {
    "amount": "Amount",
    "departureDate": "Departure date",
    "henWeightInGrams": "Hen weight",
    "eggs-price": "Egg price",
    "eggs-price-error": "Egg price must be a positive number",
    "pieces": "pieces",
    "hens-price": "Price of slaughtered hens",
    "hens-price-error": "Price of slaughtered hens must be a positive number",
    "eggs-price-second-kind": "Second grade egg price",
    "eggs-price-second-kind-error": "Second grade egg price must be a positive number",
    "hen-weight-error": "Hen weight must be a positive number",
    "hen-weight-comparison-error": "Weight must be greater than on arrival",
    "minimum-amount-of-hens-error": "Amount of hens must be a positive number",
    "amount-of-hens-comparison-error": "Amount of hens cannot be greater than on arrival",
    "departure-date-comparison-error": "Departure date must be on or after the first allowed date"
  },
  "report": {
    "title_all": "Flock Report",
    "title_summary": "Flock Summary Report",
    "title_animalcount": "Animal Count Report",
    "animalcount": {
      "year": "Flock Summary Report year:",
      "year-placeholder": "- select a year -",
      "farmcompany": "Farm Company",
      "customernr": "Customer number",
      "contactperson": "Contactpersoon",
      "location": "Location",
      "flock": "Flock",
      "barn": "Barn",
      "arrivaldate": "Arrival date",
      "arrivalamount": "Arrival amount",
      "departuredate": "Departure date",
      "departureamount": "Departure amount",
      "mutationdate": "Mutation date",
      "reason": "Reason",
      "mutation": "Mutation",
      "amountbeforemutation": "Amount before mutation",
      "amountaftermutation": "Amount after mutation",
      "numberofdays": "Number of days",
      "animaldays": "Animal days",
      "average": "Average present",
      "total": "Total",
      "reasons": {
        "EndOfLastYear": "End of last year",
        "Departure": "Departure",
        "Mortality": "Mortality",
        "EndOfYear": "End of year",
        "Today": "Today",
        "Arrival": "Arrival"
      }
    },
    "customer-details": {
      "header": "Customer information",
      "customer-number": "Customer number",
      "name": "Name",
      "address": "Address",
      "city": "Postal code and City",
      "phone": "Phone",
      "location-name": "Location name",
      "location-address": "Location address",
      "location-city": "Location postal code and city",
      "location-phone": "Location phone"
    },
    "flock-details": {
      "header": "Flock details",
      "flock": "Flock",
      "breed": "Breed",
      "amount-of-hens": "Amount of hens",
      "marketing-standard": "Marketing standard",
      "arrival-date": "Arrival date",
      "departure-date": "Departure date",
      "age-start-production-period": "Age start production period",
      "days": "days",
      "barn": "Barn"
    },
    "week-details": {
      "header": "Week registrations",
      "week": "Week",
      "cumulative": "Cumulative",
      "weekStart": "Week start",
      "AverageEggWeight": "Avg egg weight (g)",
      "AverageEggWeightPerLayerPerDay": "Egg weight/layer (g)",
      "AverageLayerWeight": "Layer weight (g)",
      "EggCountPerLayerInProduction": "Eggs per layer",
      "EggCountPerLayerInProductionCumulative": "Eggs per layer cum",
      "FeedConsumption": "Feed weight (kg)",
      "FeedConsumptionPerLayerInProduction": "Feed weight per layer (kg)",
      "FeedConsumptionPerLayerInProductionCumulative": "Feed weight per layer cum (kg)",
      "FeedConsumptionPerLayerPerDay": "Feed phpd (g)",
      "FeedConsumptionPerLayerPerDayCumulative": "Feed phpd cum (g)",
      "FeedConversionRate": "Feed conversion",
      "FeedConversionRateCumulative": "Feed conversion cum",
      "FeedToEggRatio": "Feed/Egg (g)",
      "MortalityCount": "Mortality count",
      "MortalityRate": "Mortality rate",
      "MortalityRateCumulative": "Mortality rate cum",
      "RateOfLay": "Rate of lay",
      "TotalEggCount": "Egg count",
      "TotalEggCountSecondGrade": "Egg count second grade",
      "TotalEggWeight": "Total egg weight (kg)",
      "TotalEggWeightPerLayerInProductionCumulative": "Egg weight per layer cum (kg)",
      "WaterConsumption": "Water (L)",
      "WaterToFeedRatio": "Water/Feed",
      "SecondFeedConsumption": "2nd Feed weight (kg)"
    }
  },
  "validation-error": {
    "required": "Required field",
    "title": "Validation Error",
    "description": "All fields have to be filled."
  },
  "delivery-title": "Deliveries",
  "delivery": {
    "search-placeholder": "Search in delivery notes",
    "overview-title": "Deliveries Overview",
    "empty-title": "No deliveries found",
    "empty-description": "No deliveries were found for this location.",
    "overview-table": {
      "deliveryDate": "Date",
      "deliveryNote": "Delivery note",
      "orderNr": "Order nr",
      "productNr": "Product ID",
      "productName": "Product name",
      "amount": "Amount",
      "units": "Units",
      "isActive": "Active",
      "flock": "Flock",
      "edit-title": "Edit Flock Delivery"
    }
  },
  "product-title": "Products",
  "product-save": "Save product",
  "product-saved": "Product saved!",
  "product-overview": {
    "title": "Product Overview",
    "overview": {
      "productName": "Name",
      "productCode": "Product code",
      "isActive": "Active",
      "productType-Feed": "Feed",
      "productType-Additive": "Additive",
      "type": "Product type"
    },
    "no-products": {
      "title": "No products found",
      "description": "By clicking Add a product can be created."
    },
    "delete-confirmation-title": "Delete product",
    "delete-confirmation-message": "Are you sure you want to remove this product?",
    "country": "Country"
  },
  "create-product": {
    "title-create": "New Product",
    "title-edit": "Edit Product:",
    "product-name": "Product Name",
    "product-code": "Product Code",
    "error-product-name": "Please fill in the name of the product.",
    "error-product-code": "Please fill in the product code of the product.",
    "error-code-name-already-in-use": "Please use a unique combination of name and code",
    "product-type": {
      "label": "Product type",
      "Feed": "Feed",
      "Additive": "Additive"
    },
    "error-product-type": "Product type is required."
  },
  "countries": {
    "BE": "Belgium",
    "DE": "Germany",
    "FR": "France",
    "NL": "Netherlands",
    "JO": "Jordan",
    "NG": "Nigeria",
    "TZ": "Tanzania",
    "KE": "Kenya",
    "UG": "Uganda"
  },
  "confirm-delete-flock-week-registration": "Are you sure you want to delete the week registration?",
  "flock-week-registration-deleted": "The week registration was deleted.",
  "feed-advice": {
    "overview": {
      "title": "Feed Advice Overview",
      "empty": {
        "title": "Feed advice items unavailable",
        "description": "There are no feed advice items available at this moment."
      },
      "table-header": {
        "name": "Name",
        "created": "Created",
        "updated": "Updated",
        "updatedAdvisorName": "Updated by",
        "isActive": "Active"
      },
      "buttons": {
        "add": "Create Feed Advice",
        "edit": "Edit",
        "delete": "Delete"
      }
    },
    "create-from-reference": {
      "title": "Create Feed Advice",
      "scratch-title": "Start from scratch",
      "scratch-option-title": "Start a feed advice",
      "scratch-button": "Start from scratch",
      "scratch-option-subtitle": "This is an empty feed advice",
      "reference-schemes-title": "Choose a reference feed advice as base",
      "reference-schemes-button": "Start with ",
      "product": "Product",
      "products": "Products",
      "additive": "Additive",
      "additives": "Additives"
    },
    "dialog": {
      "deleteConfirm": "Are you sure you want to delete this feed advice?",
      "deleteConfirmWhenInUse": "This feed advice is linked to a cycle, are you sure you want to delete this feed advice?"
    },
    "create": {
      "print": "Print",
      "title": "Feed advice",
      "name": "Feed advice name",
      "error-name": "A name for the feed advice is required.",
      "description": "Description",
      "description-placeholder": "Feed advice description",
      "product-placeholder": "- select a product -",
      "add-product": "Add product",
      "table-header": {
        "productName": "Product",
        "ageFrom": "Age from (weeks)",
        "ageTo": "Age to (weeks)",
        "comment": "Comments",
        "age": "Age (weeks)",
        "dosage": "Dosage (kg/tonne)",
        "applicationMoment": "Application moment"
      },
      "created": "Created",
      "updated": "Updated",
      "validation-error": {
        "title": "Validation error(s)",
        "feedadvice-name": "Feedadvice name is required",
        "age-from": "Age from is required",
        "product": "Product is required",
        "age-to": "Age to is required (except in the last line)",
        "age-min-max": "Age From should be lower than Age To."
      },
      "products": "Base advice",
      "additives": "Additives",
      "show-additives": "Show additives",
      "add-additive": "Add addition"
    },
    "print": {
      "farmcompany": "Company",
      "customernr": "Customer Number",
      "contactperson": "Contactperson",
      "location": "Location",
      "customerservice": "Customer Service",
      "table-header": {
        "productName": "Product",
        "comment": "Comments",
        "dosage": "Dosage",
        "units_kgton": "kg/tonne",
        "applicationMoment": "Application moment",
        "units_weeks": "(weeks)",
        "age": "Age"
      }
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Reference Feed Advice Overview",
      "empty": {
        "title": "Reference feed advice items unavailable",
        "description": "There are no reference feed advice items available at this moment."
      },
      "table-header": {
        "name": "Name",
        "created": "Created",
        "updated": "Updated",
        "updatedAdvisorName": "Updated by",
        "isActive": "Active"
      },
      "buttons": {
        "add": "Create Reference Feed Advice",
        "edit": "Edit",
        "delete": "Delete"
      },
      "country": "Country"
    },
    "dialog": {
      "deleteConfirm": "Are you sure you want to delete this reference feed advice?"
    },
    "create": {
      "title": "Reference Feed advice",
      "name": "Reference feed advice name",
      "error-name": "A name for the reference feed advice is required.",
      "description": "Description",
      "description-placeholder": "Reference feed advice description",
      "product-placeholder": "- select a product -",
      "add-product": "Add product",
      "table-header": {
        "productName": "Product",
        "ageFrom": "Age from (weeks)",
        "ageTo": "Age to (weeks)",
        "comment": "Comments"
      },
      "created": "Created",
      "updated": "Updated"
    }
  },
  "housing-systems": {
    "aviary": "Aviary",
    "cages": "Cages",
    "colony": "Colony",
    "floor": "Floor",
    "free-range": "Free Range",
    "furnished-cages": "Furnished cages",
    "organic": "Organic"
  },
  "sustainability": {
    "workflow": {
      "new-calculation": "New calculation",
      "requirements-met": "requirements met",
      "inputs-title": "Calculation inputs",
      "climate-change": "Climate change",
      "source": "Source",
      "outputs": {
        "eggs": "Eggs",
        "hens": "Spent hens",
        "egg-unit": "kg CO₂ eq / kg eggs",
        "hen-unit": "kg CO₂ eq / kg hen body weight"
      },
      "requirements-title": "Requirements",
      "data-complete": "Required data complete.",
      "saved-result": "Saved result",
      "previous-calculations": "Previous calculations",
      "history-description": "Select a calculation to view its result.",
      "results-title": "Calculation results",
      "issue-details": "View details",
      "missing-fields": "Missing or invalid data",
      "no-impact-values": "This calculation has no footprint values.",
      "result-errors": "This calculation contains errors.",
      "fields": {
        "UnitVolumeType": "Delivery unit",
        "Co2Total": "Total CO₂",
        "Biogenic": "Biogenic CO₂",
        "FossilExcludingPeatEmissions": "Fossil CO₂ excluding peat",
        "FossilPeatEmissions": "Peat CO₂",
        "LandUseChange": "Land-use change",
        "DryMatterAmount": "Dry matter",
        "RoughProtein": "Crude protein",
        "ProductCode": "Product code",
        "SourceDeliveryLineId": "Delivery source",
        "SourceIdentifier": "Source reference",
        "LocationId": "Farm location",
        "DeliveryId": "Delivery",
        "DeliveryLineNumber": "Delivery line",
        "UsedKg": "Used kg",
        "DeliveredKg": "Delivered weight",
        "DeliveryType": "Delivery type",
        "Co2TotalMismatch": "Total CO₂ does not equal the sum of biogenic CO₂, fossil CO₂ excluding peat, peat CO₂ and land-use change emissions. Ask your advisor or support to verify and correct the source emission values for this delivery line, then check the inputs again. Changing the used kg will not resolve this mismatch."
      },
      "checking": "Checking saved calculation inputs…",
      "readiness-error": "The input check failed. Try again.",
      "retry": "Try again",
      "ready": "Ready",
      "incomplete": "Needs attention",
      "correct-resources": "Correct farm resources",
      "check-again": "Check inputs again",
      "submitting": "Importing feeds and submitting the calculation…",
      "loading-results": "Loading calculations…",
      "results-error": "Results could not be loaded. Existing calculations are retained.",
      "pending": "Calculation is pending. This page checks results for up to 10 minutes. Check again or return later.",
      "failed": "The latest calculation failed or timed out. Check inputs and retry, or refresh the result.",
      "no-results": "No calculation available for this flock.",
      "calculation": "Calculation",
      "history-notice": "This is a saved calculation. Later balance or registration changes do not update it; calculate again to include them.",
      "result-invalid": "This saved result could not be read. Contact support.",
      "requirements": {
        "flock": "Flock and production",
        "farm-resources": "Farm resources",
        "bedding": "Bedding",
        "feeds": "Saved feed balance"
      },
      "issues": {
        "flock-not-found": "This flock is unavailable in the selected farm. Select the correct farm and flock.",
        "flock-dates-invalid": "Correct arrival and departure dates. The flock must be closed.",
        "arrival-data-invalid": "Enter a positive arrival count and hen weight in flock details.",
        "departure-data-invalid": "Enter a positive departure count and hen weight in flock details.",
        "departure-weight-below-arrival": "Departure hen weight must be at least the arrival weight.",
        "production-data-missing": "Complete production registrations, including egg count and egg weight.",
        "farm-resources-missing": "Enter farm resources for the missing year.",
        "farm-resources-not-calculated": "Save farm resources to calculate the allocation for this flock.",
        "bedding-type-missing": "Select bedding type in flock arrival details.",
        "bedding-amount-missing": "Enter the bedding amount in flock arrival details.",
        "feed-balance-not-saved": "Enter and save this flock’s feed balance.",
        "feed-balance-empty": "Save at least one positive used kg quantity in the feed balance.",
        "feed-source-missing": "This exact source is unavailable. Clear its quantity in the feed balance and explicitly enter it against the correct source.",
        "feed-data-invalid": "Delivery source data is incomplete or invalid. Contact support with this line and the listed fields, or correct the source in the feed balance.",
        "feed-settings-missing": "Sustell customer configuration or the farm country is missing. Contact support.",
        "calculation-not-ready": "Saved inputs changed or are incomplete. Correct the issues and try again.",
        "feed-import-failed": "Feeds could not all be imported or resolved. Correct source data or contact support, then retry. No baseline was submitted.",
        "sustell-submission-failed": "The calculation could not be submitted. Try again or contact support. Previous results are retained."
      },
      "check-results": "Check results again",
      "correct-flock": "Correct flock details and registrations",
      "statuses": {
        "available": "Calculated",
        "failed": "Failed",
        "pending": "Pending",
        "inprogress": "In progress",
        "timedout": "Timed out",
        "missing": "Missing"
      }
    },
    "sustainability": "Sustainability",
    "add-farm-resources": "Add farm resources",
    "farm-resources": "Energy consumption per year",
    "carbon-footprint": "Carbon footprint",
    "confirm-delete-farm-resource": "Delete the farm resource?",
    "farm-resource-deleted": "Farm resource deleted",
    "farm-resource-saved": "Farm resource saved",
    "year": "Year",
    "resource": {
      "electricity": "Electricity (kWh)",
      "electricity-photovoltaic": "Electricity Sun (kWh)",
      "electricity-wind": "Electricity Wind (kWh)",
      "natural-gas": "Natural gas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Gasoline (L)",
      "coal": "Coal (KG)",
      "propane-lpg": "Propane / LPG (L)",
      "water": "Water (m³)",
      "flock-start-date": "Start date",
      "flock-end-date": "End date",
      "status": "Status",
      "statuses": {
        "complete": "Complete",
        "partial": "Partial",
        "active": "Active"
      },
      "water-error": "Water must be a positive number",
      "electricity-error": "Electricity must be a positive number",
      "electricity-photovoltaic-error": "Electricity sun must be a positive number",
      "electricity-wind-error": "Electricity wind must be a positive number",
      "natural-gas-error": "Natural gas must be a positive number",
      "diesel-error": "Diesel must be a positive number",
      "gasoline-error": "Gasoline must be a positive number",
      "propane-lpg-error": "Propane / LPG must be a positive number",
      "coal-error": "Coal must be a positive number"
    },
    "farm-settings-saved": "Farm settings saved",
    "farm-settings-enable-co2-calculation": "Enable CO2 calculations for this farm",
    "flock-resources": "Flock resources",
    "consumptionEgg": "Value eggs (kg CO2eq / kg eggs)",
    "spentHens": "Value slaughtered hens (kg CO2eq / kg hen body weight)",
    "notification-title": "Important information about CO2 calculations",
    "notification-description": "The calculation of the carbon footprint is powered by LCA software Sustell. As background the CO2 feed calculations are performed in accordance with the current Nevedi instruction. To supply a correct calculation, all data needs to be entered completely such as <b>technical results of a flock incl. production and departure/slaughter and energy consumption.</b>\nDisplayed values may be subject to change due to adaptation of climate science and subsequent changes in calculation systems, as well as changes in laws and regulations and any applicable standards. Although the information shown here has been compiled with care, no rights may be derived from it.",
    "action-text-close": "Hide",
    "action-text-open": "Show",
    "farm-resources-not-complete": "Flock resources are not complete.",
    "bedding-type-required": "Arrival - Bedding type is required for the flock.",
    "bedding-amount-required": "Arrival - Bedding amount is required for the flock.",
    "hen-weight-required": "Arrival - Hen Weight is required for the flock.",
    "start-calculation": "Start calculating CO2",
    "refresh-carbon-footprint": "Refresh CO2 footprint",
    "carbon-footprint-title-error": "Carbon Footprint Calculation Error",
    "carbon-footprint-title": "Carbon Footprint Calculation",
    "carbon-footprint-text": "The carbon footprint calculation will start. Please be patient while the process completes (approximately 1 minute).",
    "carbon-footprint-refresh-error-title": "Refresh Carbon Footprint Error",
    "week-registrations-required": "Week registration data is required for carbon footprint calculation.",
    "day-registrations-missing": "Daily registration data is missing for some week periods.",
    "week-registrations-incomplete": "Week registrations must contain valid data for the entire flock period.",
    "carbon-footprint-500-error-message": "There was an error calculating the carbon footprint. This may be because your week registration data is incomplete or missing. Please ensure you have filled in production data (eggs, feed consumption, mortality, etc.) for your flock period before trying again."
  },
  "bedding-types": {
    "NoBedding": "No bedding",
    "BarleyStraw": "Barley straw",
    "MaizeStover": "Maize stover",
    "OatStraw": "Oat straw",
    "SawDust": "Saw dust",
    "SunflowerHusk": "Sunflower husk",
    "WheatStraw": "Wheat straw",
    "Woodshavings": "Woodshavings"
  },
  "feed-systems": {
    "Ketting": "Chain feeding",
    "Pannen": "Pan feeding",
    "Spiraal": "Spiral feeding"
  },
  "drink-systems": {
    "Cups": "Cups",
    "Nippels": "Nipples",
    "RondDrinkers": "Rond drinkers"
  },
  "nests": {
    "WegrolNest": "Roll-away nest",
    "Handgeraapt": "Hand collected"
  },
  "title_Agravis": "Avidata Legehenne",
  "feed-balance": {
    "weight-unavailable": "Weight unavailable",
    "correction-help": "To correct an unavailable line, clear its used kg, find the intended active line, enter the kg there and save. Quantities are never transferred automatically. Activate inactive new lines on the Deliveries page before allocating kg.",
    "search": "Search",
    "no-matches": "No deliveries match these filters.",
    "period-start": "Deliveries from",
    "period-end": "Through",
    "show-all-dates": "Show all deliveries",
    "use-flock-period": "Use period",
    "period-notice": "Saved and entered quantities remain visible outside the selected period.",
    "title": "Feed balance",
    "flock": "Flock",
    "saved": "Saved",
    "not-registered": "Not registered",
    "delivery-date": "Delivery date",
    "delivery-number": "Delivery",
    "order-number": "Order number",
    "delivered-weight": "Delivered weight",
    "delivery-note": "Delivery note",
    "line-number": "Line",
    "feed": "Feed",
    "delivered": "Delivered",
    "used-kg": "Used by this flock (kg)",
    "used-kg-short": "Used (kg)",
    "total": "Total used",
    "save": "Save balance",
    "saving": "Saving…",
    "cancel": "Back to flocks",
    "loading": "Loading feed balance…",
    "empty": "No active feed deliveries or saved allocations at this location.",
    "missing-delivery-line": "Delivery line no longer available",
    "inactive": "Inactive delivery",
    "save-success": "Feed balance saved.",
    "load-error": "Feed balance could not be loaded. Return to flocks and try again.",
    "unavailable-allocation": "This new allocation cannot be saved. Clear its quantity and choose an available delivery line.",
    "delivery-line-unavailable": "Delivery lines have changed. Refresh the page before saving again. Refreshing discards your unsaved changes.",
    "save-error": "Save failed. Your changes are still here; please try again.",
    "conflict": "Balance changed elsewhere. Refresh the page to load the latest version. Refreshing discards your unsaved changes.",
    "invalid-input": "Enter zero or positive kg, with at most three decimal places.",
    "unsaved-title": "Unsaved feed balance",
    "unsaved-message": "Leave this page and discard your changes?",
    "calculation-notice": "These quantities are saved separately. The current footprint calculation does not use this balance yet."
  }
}
